export interface TVideoState {
  isFullScreen: boolean;
  isHideVideo: boolean;
}

enum ActionTypes {
  SET_VIDEO = '@@video/SET_VIDEO',
  SET_VIDEO_HIDE = '@@video/SET_VIDEO_HIDE',
}

export default ActionTypes;
